import SubPage from "../subpages/SubPage";
import Apply from "../subpages/Apply";
import Search from "../subpages/Search";
// import Payment from '../components/Payment';
import { Switch, Route } from "react-router-dom";
import { Container } from "react-bootstrap";
import PayComplete from "../components/PayComplete";
import SearchId from "../subpages/SearchId";
// import PayCompleteTest from '../components/PayCompleteTest';
// import { useState } from 'react';
const Application = () => {
  const title = "참가 신청";
  const parent_link = "apply";
  const side_list = [
    ["individual", "개인 신청"],
    ["group", "단체 신청(2인 이상)"],
    // ['trekking', '언텍트 트레킹 신청'],
    ["search", "신청 조회 및 수정"],
    ['searchId', '접수 번호 조회'],
  ];
  const bg_info = {
    link: "/application_banner.jpeg",
    text: title,
  };

  return (
    <div style={{ minHeight: "70rem" }}>
      <SubPage
        title={title}
        parent_link={parent_link}
        side_list={side_list}
        background_info={bg_info}
      />
      <Container fluid className="col-lg-8 offset-lg-3">
        <Switch>
          <Route path={`/${parent_link}/searchId`} component={SearchId} />
          <Route path={`/${parent_link}/search`} component={Search} />
          <Route
            path={`/${parent_link}/success`}
            component={PayComplete}
            // render={({ history }) => (
            //   <PayComplete ticketInfo={ticketInfo} history={history} />
            // )}
          />
          {/* Apply에는 history도 넘겨줘야함!!! */}
          {/* <Route path={`/${parent_link}/online`} component={Apply} /> */}
          {/* <Route path={`/${parent_link}/offline`} component={Apply} /> */}
          {/* <Route path={`/${parent_link}/trekking`} component={Apply} /> */}
          <Route path={`/${parent_link}/individual`} component={Apply} />
          <Route path={`/${parent_link}/group`} component={Apply} />
          {/* <Route path={`/${parent_link}/payment`} component={Payment} /> */}
        </Switch>
      </Container>
    </div>
  );
};
export default Application;
